
module.exports = {
  // TODO: change your profile information here
  name: "Priyanshu Katiyar",
  greeting: "Hey 👋",
  greetingDescription: "I'm Priyanshu Katiyar. Welcome to my Page.",
  githubUrl: "https://github.com/priyanshukatiyar14",
  linkedinUrl: "https://www.linkedin.com/in/priyanshukatiyar",
  cvLink: "https://drive.google.com/file/d/1VpqYgj7nQ7nCfbrYenMr9oLf7XukWc43/view?usp=drivesdk",
};
